/**
 * Constants
 * */
export const IS_MOBILE = 'IS_MOBILE'

/**
 * Reducer
 * */
export const mobileReducer = (mobile = false, action) => {
    return action.type === IS_MOBILE ? action.mobile : mobile
}

/**
 * Action Creators
 * */
export const isMobile = (mobile) => ({ type: IS_MOBILE, mobile })
